import React from 'react';
import { ArrowUpwardRounded, AttachFile as AttachFileIcon, CloseRounded, FileCopy } from '@material-ui/icons';
import { Button } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import showToastMessage from '../../util/showToastMessage';
import { isExxonMobileEmail } from '../Validator';
import { CommonPromptBox } from '../../components/ui';
import JurisdictionChip from '../../components/JurisdictionChip';
import { ACCEPT_ATTR, IMAGE_MIME_TYPES } from '../../utils/fileAccept';

const StyledTooltip = styled(ReactTooltip)`
  max-width: 15% !important
`;

const DeepSearchInput = ({ value, onChange, onEnter, uploadAttachment, filePreviews, removeAttachment, context, textareaRef, disabled }: any) => {
  const attachmentsDisabled = isExxonMobileEmail(context) || !!disabled;
  return (
    <div className="deep-search-input-root">
      <input
        id="file-input-deep-search"
        type="file"
        multiple
        accept={ACCEPT_ATTR}
        onChange={uploadAttachment}
        className="cmn-display-none"
        disabled={attachmentsDisabled}
      />
      <div className={ filePreviews && filePreviews.length ? 'd-flex mb-2 overflow-auto' : 'd-none' }>
        {filePreviews && filePreviews.map((file: any, index: number) => {
          return IMAGE_MIME_TYPES.includes(file.type) ? (
            <div className="preview-img mr-1" key={index}>
              <img src={file.preview} alt={file.name} width="200" />
              <Button variant="outline-dark" className="close-button" onClick={() => removeAttachment(index)}><CloseRounded /></Button>
            </div>
          ) : (
            <div className="preview-file" key={index}>
              <FileCopy color="primary" />
              <div>
                <p>{ file.name }</p>
                <p>{ file.type }</p>
              </div>
              <Button variant="outline-dark" className="close-button" onClick={() => removeAttachment(index)}><CloseRounded /></Button>
            </div>
          );
        })}
      </div>
      <div className="deep-search-input-wrap">
        <CommonPromptBox
          value={value}
          onChange={onChange}
          onSubmit={onEnter}
          className="cmn-chem-searchbox"
          variant="hero"
          placeholder="Ask about permits, air quality, water rights, compliance..."
          inputRef={textareaRef}
          autoFocus
          disabled={!!disabled}
          leftSlot={(
            <div className="image-upload">
              <label
                htmlFor={attachmentsDisabled ? undefined : 'file-input-deep-search'}
                className={`${attachmentsDisabled ? 'text-secondary' : 'text-light'} ${disabled ? 'deep-search-attach--busy' : 'cmn-pointer'}`}
                data-tip="This feature is disabled for ExxonMobil. Please contact the Administrator."
                data-for="exxon"
                onClick={() => {
                  if (disabled) {
                    return;
                  }
                  if (isExxonMobileEmail(context)) {
                    showToastMessage({ type: 'warn', title: 'Warning', description: 'This Feature is disabled for ExxonMobil. Please contact the Administrator.' });
                  }
                }}
              >
                <AttachFileIcon />
              </label>
              { isExxonMobileEmail(context) && <StyledTooltip id="exxon" place="top" effect="solid" /> }
              <JurisdictionChip />
            </div>
          )}
          submitIcon={<ArrowUpwardRounded className="cmn-chem-searchbox__send-icon" style={{ fontSize: 24 }} />}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              onEnter();
            }
          }}
        />
      </div>
    </div>
  );
};

export default DeepSearchInput;